import React from 'react'
import PropTypes from 'prop-types'
import copy from './copy'
import hasModel from './utils'
import styles from './styles.scss'

const FitGuidance = ({ product, selectedOption, rating, t, summaryLabel }) => {
  if (!hasModel(product.model)) return null
  const selected = product.attributes?.find(
    (item) =>
      item.id_product_attribute === selectedOption?.id_product_attribute,
  )
  const fixedUnits = (product.measurement_spec || [])
    .filter((item) => item.is_fix_unit)
    .map((item) => item.name)
  const measurements = (selected?.measurements || []).filter(
    (item) =>
      !fixedUnits.includes(item.name) &&
      item.name &&
      item.value != null &&
      String(item.value).trim(),
  )
  const type = ['body', 'product'].includes(product.measurement_type)
    ? product.measurement_type
    : 'other'
  const fit = ['loose', 'true_to_size', 'tight'].includes(
    rating?.avg_rating_true_to_size,
  )
    ? rating.avg_rating_true_to_size
    : null
  const text = (key, values) => copy(t, key, values)
  return (
    <details className="pdp-guidance" data-cy="pdp-fit-guidance">
      <style jsx>{styles}</style>
      <summary>{summaryLabel || text('model', product.model)}</summary>
      <div className="guidance-body">
        {!selected ? (
          <p>{text('selectSize')}</p>
        ) : (
          <React.Fragment>
            <p>
              {text('measurements', { size: selected.size, type: text(type) })}
            </p>
            {measurements.length ? (
              <dl>
                {measurements.map((item) => (
                  <React.Fragment key={item.name}>
                    <dt>{item.name}</dt>
                    <dd>{item.value}</dd>
                  </React.Fragment>
                ))}
              </dl>
            ) : (
              <p className="guidance-note">{text('noMeasurements')}</p>
            )}
          </React.Fragment>
        )}
        {fit && <p>{text(fit)}</p>}
      </div>
    </details>
  )
}
FitGuidance.defaultProps = {
  summaryLabel: null,
  selectedOption: null,
  rating: null,
}
FitGuidance.propTypes = {
  summaryLabel: PropTypes.string,
  product: PropTypes.shape({
    model: PropTypes.shape({
      height: PropTypes.number,
      size: PropTypes.string,
    }),
    attributes: PropTypes.arrayOf(PropTypes.shape({})),
    measurement_spec: PropTypes.arrayOf(
      PropTypes.shape({ name: PropTypes.string, is_fix_unit: PropTypes.bool }),
    ),
    measurement_type: PropTypes.string,
  }).isRequired,
  selectedOption: PropTypes.shape({ id_product_attribute: PropTypes.number }),
  rating: PropTypes.shape({ avg_rating_true_to_size: PropTypes.string }),
  t: PropTypes.func.isRequired,
}
export default FitGuidance
